
import { Clock } from 'lucide-react';
import { motion } from 'framer-motion';

interface FortuneTimerProps {
  nextFortuneTime: string;
}

const FortuneTimer = ({ nextFortuneTime }: FortuneTimerProps) => {
  return (
    <motion.div 
      className="mt-8 text-sm text-muted-foreground flex items-center space-x-2 bg-black/5 px-4 py-2 rounded-full"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.6 }}
    >
      <Clock size={16} />
      <span>Next free fortune in: {nextFortuneTime}</span>
    </motion.div>
  );
};

export default FortuneTimer;
